import React, { FC } from 'react';

import { TabProps } from './CustomerSites.props';
import SitesTable from './SitesTable';

const ActiveSites: FC<TabProps> = (props) => (
  <SitesTable {...props} queryScope="active" activeOnly={1} />
);

export default ActiveSites;
